import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Bien joué !")
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "center" }

import { JourneyData } from '@/model/Journey'
import { Player } from '@/model/Player'
import { PropType } from 'vue'

import GameTitle from '@/components/game/basics/GameTitle.vue'
import GameText from '@/components/game/basics/GameText.vue'
import GameButton from '@/components/game/basics/GameButton.vue'
import GameImages from '@/components/game/basics/GameImages.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'GamePlayerCompleted',
  props: {
  player: {
    type: Object as PropType<Player>,
    required: true,
  },
  journey: {
    type: Object as PropType<JourneyData>,
    required: true,
  },
},
  emits: ["logout", "end"],
  setup(__props, { emit: emits }: { emit: ({
  (event: 'logout'): void
  (event: 'end'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(GameTitle, { class: "game-title" }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }),
    _createVNode(GameText, null, {
      default: _withCtx(() => [
        (!__props.player.alternative)
          ? (_openBlock(), _createElementBlock("p", {
              key: 0,
              innerHTML: __props.journey.outro
            }, null, 8, _hoisted_2))
          : _createCommentVNode("", true),
        (__props.player.alternative)
          ? (_openBlock(), _createElementBlock("p", {
              key: 1,
              innerHTML: __props.journey.outroAlternative
            }, null, 8, _hoisted_3))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(GameImages, {
      images: __props.journey.outroImages
    }, null, 8, ["images"]),
    _createElementVNode("div", _hoisted_4, [
      (!__props.journey.hasReward)
        ? (_openBlock(), _createBlock(GameButton, {
            key: 0,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('logout')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('View.Player.Start.quit')), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (__props.journey.hasReward)
        ? (_openBlock(), _createBlock(GameButton, {
            key: 1,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('end')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('View.Player.Start.getYourReward')), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})